import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OptimizerServiceService {

  // TODO : Change this on production
   public static CHAPTIMIZER_API_URL = "https://chapwood-optimizer.chapwood.apps.savantly.cloud/";
  // public static CHAPTIMIZER_API_URL = "http://103.249.97.239/";
    // private static CHAPTIMIZER_API_URL = "http://127.0.0.1:5002/";

  constructor() { }

  public getEndpointURL(){
    return OptimizerServiceService.CHAPTIMIZER_API_URL+"optimize";
  }

  public getAuthenticationEndpointURL(){
    return OptimizerServiceService.CHAPTIMIZER_API_URL+"authenticate";
  }

  public getPortfolioTrendEndpointURL(){
    return OptimizerServiceService.CHAPTIMIZER_API_URL+"calculatePortfolioTrend";
  }

  public getMonthlyReturnsEndpointURL(){
    return OptimizerServiceService.CHAPTIMIZER_API_URL+"calculateMonthlyReturns";
  }

  public getPdfFileURL()
  {
   return OptimizerServiceService.CHAPTIMIZER_API_URL + 'downloadPDf';
  }

}
